export abstract class ResendLastBookingConfirmationEmailService {
  requestResendBookingConfirmationEmail(_email: string): Promise<void> {
    throw new Error('Not implemented')
  }
}
